// extracted by mini-css-extract-plugin
module.exports = {"container":"MapDemo_container__3CsN1","placeStack":"MapDemo_placeStack__20xYV"};